import { all, put, takeLatest } from 'redux-saga/effects';
import imageCompression from 'browser-image-compression';
import { getCurrentTenant, getValidToken } from '../../common/util/RestClient';
import envConfig from '../../config';

import { uploadProfileImage, uploadPublicImage } from '../routines';
import SUCCESS_MESSAGES from '../../common/constants/SuccessMessagesConstants';
import {
  PROFILE_IMAGE_UPLOAD,
  PUBLIC_IMAGE_UPLOAD_SERVICE_DIRECTORIES,
} from '../../common/constants/CommonConstants';

function* uploadImageSaga({ payload }) {
  try {
    const { image, entity, imageId } = payload;

    if (entity) {
      const authToken = yield getValidToken();
      const tenantId = yield getCurrentTenant();
      const options = {
        maxSizeMB: 2,
        maxWidthOrHeight: 600,
        useWebWorker: true,
        fileType: 'image/jpeg',
      };
      const compressedFile = yield imageCompression(image, options);

      const myHeaders = new Headers();
      myHeaders.append('authorization', authToken);
      myHeaders.append('Tenant-Id', tenantId);

      const formdata = new FormData();
      compressedFile.name = 'avatar_Image.jpg';

      formdata.append('image', compressedFile, compressedFile.name);
      const requestOptions = {
        method: 'PUT',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow',
      };

      let uID = '';
      yield fetch(
        `${envConfig.APIG_URL}file-management/image/${entity}s`,
        requestOptions
      )
        .then((response) => response.json())
        .then((response) => {
          uID = response.data.imageUID;
        });

      if (entity === PROFILE_IMAGE_UPLOAD) {
        yield put(
          uploadProfileImage.success({
            imageId: uID,
          })
        );
      } else {
        yield put(
          uploadProfileImage.success({
            imageId: uID,
            successMessage: SUCCESS_MESSAGES.IMAGE_UPLOAD,
          })
        );
      }
    } else {
      yield put(uploadProfileImage.success({ imageId }));
    }
  } catch (error) {
    yield put(uploadProfileImage.failure({ error }));
  }
}
function* uploadPublicImageSaga({ payload }) {
  try {
    const { image, directory, imageId } = payload;

    if (
      Object.values(PUBLIC_IMAGE_UPLOAD_SERVICE_DIRECTORIES).includes(directory)
    ) {
      const authToken = yield getValidToken();
      const tenantId = yield getCurrentTenant();

      const options = {
        maxSizeMB: 2,
        maxWidthOrHeight: 600,
        useWebWorker: true,
        fileType: image.type,
      };
      const compressedFile = yield imageCompression(image, options);

      const myHeaders = new Headers();
      myHeaders.append('authorization', authToken);
      myHeaders.append('Tenant-Id', tenantId);

      const formdata = new FormData();
      compressedFile.name = image.name;

      formdata.append('image', compressedFile, compressedFile.name);
      const requestOptions = {
        method: 'PUT',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow',
      };

      let uID = '';
      yield fetch(
        `${envConfig.APIG_URL}file-management/image/public/${directory}`,
        requestOptions
      )
        .then((response) => response.json())
        .then((response) => {
          uID = response.data.imageUID;
        });

      yield put(
        uploadPublicImage.success({
          imageId: uID,
        })
      );
    } else {
      yield put(uploadPublicImage.success({ imageId }));
    }
  } catch (error) {
    yield put(uploadPublicImage.failure({ error }));
  }
}

export default function* root() {
  yield all([
    takeLatest(uploadProfileImage.TRIGGER, uploadImageSaga),
    takeLatest(uploadPublicImage.TRIGGER, uploadPublicImageSaga),
  ]);
}
